export interface MapObjectPlacementLike {
  readonly x: number;
  readonly y: number;
  readonly offsetX?: number;
  readonly offsetY?: number;
}

export interface NormalizedMapObjectPlacement {
  readonly x: number;
  readonly y: number;
  readonly offsetX: number;
  readonly offsetY: number;
  readonly sizeMultiplier: number;
}

function clampOffset(offset: number): number {
  const safeOffset = Number.isFinite(offset) ? offset : 0;
  return Math.max(-1, Math.min(1, safeOffset));
}

function normalizeSizeMultiplier(sizeMultiplier: number | undefined): number {
  if (typeof sizeMultiplier !== 'number' || !Number.isFinite(sizeMultiplier) || sizeMultiplier <= 0) {
    return 1;
  }
  return sizeMultiplier;
}

export function normalizeMapObjectPlacement<T extends MapObjectPlacementLike>(placement: T): T & NormalizedMapObjectPlacement {
  // This helper only normalizes per-instance visual metadata. Callers still own
  // any map-bounds validation or clamping for x/y tile coordinates.
  return {
    ...placement,
    x: placement.x,
    y: placement.y,
    offsetX: clampOffset(placement.offsetX ?? 0),
    offsetY: clampOffset(placement.offsetY ?? 0),
    sizeMultiplier: normalizeSizeMultiplier((placement as T & { sizeMultiplier?: number }).sizeMultiplier),
  };
}
